<template>
  <edit-form :model="$store.getters['model' + modelName]" @submit="save" />
</template>

<script>
import EditForm from "../../components/Form";

export default {
  components: {
    EditForm
  },
  computed: {
    modelName: function() {
      let name = this.$route.params.model;
      return name.charAt(0).toUpperCase() + name.substring(1);
    }
  },
  mounted() {
    this.$store.dispatch("loadModel" + this.modelName);
  },
  methods: {
    save(data) {
      this.$store.dispatch("create" + this.modelName, data).then(resp => {
        this.$router.push({
          path: `/model/${this.$route.params.model}/${resp.data.id}`
        });
      });
    }
  }
};
</script>
